
import { Component, Vue } from 'vue-property-decorator';
import { getAttributeList, addAttribute, modifyAttribute, delAttribute } from '@/api/parts';
import { UserModule } from '@/store/modules/user';
import { IPagination } from '@/types';
@Component({
  name: 'PartsProperty'
})
export default class extends Vue {
  private formSearch = {
    name: ''
  }
  private tableData = []
  private title=1
  private dialogPartPropertyVisible = false
  private textareaProperty: any = {
    id: 0,
    name: ''
  }
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  created() {
    this.getAttributeList();
  }
  private getAttributeList() {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.name = this.formSearch.name;
    params.page = this.pagination.currentPage;
    params.size = this.pagination.pageSize;
    getAttributeList(params).then(res => {
      if (res.data) {
        this.pagination.total = parseInt(res.data.count);
        this.tableData = res.data.list;
      } else {
        this.pagination.currentPage = 1;
        this.pagination.total = 0;
        this.tableData = [];
      }
    }).catch(error => {
      this.tableData = [];
      let msg = error.msg;
    });
  }
  private search() {
    this.getAttributeList();
  }
  private restSearch() {
    this.formSearch.name = '';
    this.getAttributeList();
  }
  private propertyHandle() {
    this.textareaProperty.name = '';
    this.title = 1;
    this.dialogPartPropertyVisible = true;
  }
  private modifyPropertyHandle(property:any) {
    this.title = 2;
    this.textareaProperty.id = property.id;
    this.textareaProperty.name = property.name;
    this.dialogPartPropertyVisible = true;
  }
  private deletePropertyHandle(property:any) {
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.attribute_id = property.id;
    delAttribute(params).then(res => {
      this.showSecussMsg((res as any).msg);
      this.getAttributeList();
    }).catch(error => {
      this.showErrorMsg(error.msg);
    });
  }
  private dialogConfirm() {
    if (!this.textareaProperty.name) {
      this.showErrorMsg('请输入备件属性，限20字');
      return;
    }
    let params:any = {};
    params.user_id = UserModule.getUserId;
    params.company_id = UserModule.getCompanyId;
    params.attribute_id = this.textareaProperty.id;
    params.name = this.textareaProperty.name;
    switch (this.title) {
      case 1:
        addAttribute(params).then(res => {
          this.dialogPartPropertyVisible = false;
          this.showSecussMsg((res as any).msg);
          this.getAttributeList();
        }).catch(error => {
          this.showErrorMsg(error.msg);
        });
        break;
      case 2:
        modifyAttribute(params).then(res => {
          this.dialogPartPropertyVisible = false;
          this.showSecussMsg((res as any).msg);
          this.getAttributeList();
        }).catch(error => {
          this.showErrorMsg(error.msg);
        });
        break;
    }
  }
  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getAttributeList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getAttributeList();
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
